const isDefined = (x) => x != null;

export default isDefined;
